// Import action types related to video categories
import {
  VIDEOCATEGORY_FETCH_DATA_SUCCESS,
  VIDEOCATEGORY_HAVE_ERROR,
  VIDEOCATEGORY_ARE_LOADING,
} from "../actionType";

// Define the initial state for the VideoCategory reducer
const initialState = {
  data: [], // Initialize data as an empty array
  loading: true, // Set loading to true initially
  error: [], // Initialize error as an empty array
};

// Reducer function to handle video category-related actions and update state accordingly
export function VideoCategoryReducer(state = initialState, action) {
  switch (action.type) {
    // Handle error case when fetching video categories
    case VIDEOCATEGORY_HAVE_ERROR:
      return {
        ...state,
        error: action.hasError, // Update the error state with the error from the action
        loading: false, // Set loading to false since the request is complete
      };

    // Handle loading state when video categories are being fetched
    case VIDEOCATEGORY_ARE_LOADING:
      return {
        ...state,
        loading: action.isLoading, // Update the loading state with the loading status from the action
      };

    // Handle success case when video categories are successfully fetched
    case VIDEOCATEGORY_FETCH_DATA_SUCCESS:
      return {
        ...state,
        data: action.VideoCategory, // Update the data state with the fetched video categories
        loading: false, // Set loading to false since the request is complete
        error: [], // Clear any previous errors (assuming the success case means no error)
      };

    // Return the current state by default if action type is not recognized
    default:
      return state;
  }
}
